export const GTM_ID = 'GTM-5G849N8D'

const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`

let started = false

// App events carry an `event` name; consent commands (`arguments` objects from
// gtag) and persistent variables like `{ user_id }` do not.
const isAppEvent = (entry: unknown): boolean =>
  typeof entry === 'object' &&
  entry !== null &&
  typeof (entry as { event?: unknown }).event === 'string'

/**
 * Starts the GTM container right away — the standard bootstrap snippet, minus
 * next/script's idle wait.
 *
 * Events pushed before consent (a /join visitor fills the form, then accepts
 * the banner) are moved behind `gtm.js`, so the container initialises and sends
 * the landing page_view first and only then replays the queue. Consent
 * commands and `user_id` stay ahead of `gtm.js` so page_view already sees them.
 * GTM has not hooked `dataLayer.push` yet, so reordering the array is safe.
 */
export function loadGoogleTagManager(): void {
  if (started || typeof window === 'undefined') {
    return
  }
  started = true

  const dataLayer = (window.dataLayer = window.dataLayer || [])
  const queued = dataLayer.filter(entry => isAppEvent(entry))
  const rest = dataLayer.filter(entry => !isAppEvent(entry))
  dataLayer.length = 0
  dataLayer.push(
    ...rest,
    { 'gtm.start': Date.now(), event: 'gtm.js' },
    ...queued
  )

  const script = document.createElement('script')
  script.async = true
  script.src = GTM_SRC
  document.head.append(script)
}
